/*
 * Types here are used to partially describe what happens in a large structure
 * in untyped JS codebase, therefore these types are far from complete.
 */

import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';

type ItemType = 'global' | 'stp' | 'routing';

interface DataItem<T extends ItemType = ItemType> {
  type: T;
  [key: string]: any;
}

interface Output {
  type: 'global';
  stpDomains: false | DataItem<'stp'>[];
  routingDomains: false | DataItem<'routing'>[];
  [key: string]: any;
}

export const groupDataByType = (input: DataItem[]): Output => {
  const global = input.find(
    (i): i is DataItem<'global'> => i.type === 'global',
  );
  const stpDomains = input.filter(
    (i): i is DataItem<'stp'> => i.type === 'stp',
  );
  const rDomains = input.filter(
    (i): i is DataItem<'routing'> => i.type === 'routing',
  );
  if (!global) {
    throw new IpfError('INVALID_ARGUMENT', 'missing global entry in input');
  }
  return {
    ...global,
    stpDomains: stpDomains.length > 0 ? stpDomains : false,
    routingDomains: rDomains.length > 0 ? rDomains : false,
  };
};
